import { Pow18 } from 'config'
import { useBaseCurrencyAmountCallback } from 'hooks/spot/useBaseCurrencyAmount'
import { memo, useEffect } from 'react'
import { useLinkConnected } from 'store/link/hooks'
import {
  useCreateOrderOption,
  useCurrentSpotSymbol,
  useSpotOrderDirection,
  useSpotSelectedOrderMode,
} from 'store/spot/hooks'
import { OrderDirection } from 'store/spot/types'
import { bn, e2w, isZero, parseWeiToEther, toFixed } from 'utils/number'
import { PercentSlider, PerCentWrap, SliderWrap } from './styles'
import { useSpotTradeAvailableBalance } from '../../../../hooks/spot/useSpotTradeAvailableBalance'
import { useAtom } from 'jotai'
import { orderPercentAtom } from './atoms'
import { snapToMark } from 'utils/snapToMark'

const marks = [
  {
    value: 0,
    label: '0',
  },
  {
    value: 25,
    label: '25',
  },
  {
    value: 50,
    label: '50',
  },
  {
    value: 75,
    label: '75',
  },
  {
    value: 100,
    label: '100',
  },
]

export const AmountPercent = memo(() => {
  const [percent, setPercent] = useAtom(orderPercentAtom)
  const isLinkConnected = useLinkConnected()
  const currentSymbol = useCurrentSpotSymbol()
  const {
    id = 0,
    baseCurrency = '',
    quoteCurrency = '',
    baseScale = 0,
  } = currentSymbol
  const orderDirection = useSpotOrderDirection()
  const isBuy = orderDirection === OrderDirection.LONG
  const available = useSpotTradeAvailableBalance(
    isBuy ? quoteCurrency : baseCurrency,
  )
  const orderMode = useSpotSelectedOrderMode()
  const { onBaseCurrencyAmountInput } = useBaseCurrencyAmountCallback()
  const { limitPrice } = useCreateOrderOption()

  useEffect(() => {
    setPercent(0)
  }, [id, orderMode, orderDirection])

  const percentageAmount = (numerator: number) => {
    if (isZero(available)) return ''
    if (isZero(limitPrice)) return ''

    let r = bn(available).mul(e2w(numerator)).div(100).div(Pow18)
    if (isBuy) {
      r = r.mul(Pow18).div(e2w(limitPrice))
    }

    return toFixed(parseWeiToEther(r.toString()), baseScale)
  }
  const clickPercentItem = (percent: number) => {
    if (!isLinkConnected) return
    setPercent(percent)
  }

  useEffect(() => {
    if (isZero(percent) || isZero(limitPrice) || !isLinkConnected) {
      onBaseCurrencyAmountInput('', limitPrice, true)
    } else {
      onBaseCurrencyAmountInput(percentageAmount(percent), limitPrice, true)
    }
  }, [percent, limitPrice, isLinkConnected])

  return (
    <PerCentWrap id="zk_order_slider">
      <SliderWrap>
        <PercentSlider
          step={1}
          marks={marks}
          min={0}
          max={100}
          valueLabelDisplay="auto"
          value={percent}
          onChange={(event, value, activeThumb) => {
            const val = snapToMark(Number(value), marks)
            clickPercentItem(val)
          }}
          slot="s"
        />
      </SliderWrap>
    </PerCentWrap>
  )
})
